module.exports = __webpack_public_path__ + "img/logotyp_skala_szarosci_z_latami.ee0ed6ef.jpg";